import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const CreateTeamsTabPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-createteamstabpage" */ "./CreateTeamsTabPage")).then((bundle)=>{
        return {
            default: bundle.CreateTeamsTabPage
        };
    });
export const LazyCreateTeamsTabPage = /*#__PURE__*/ lazy(CreateTeamsTabPageLazyLoader);
